import React from 'react';
import { ArrowUpRight, Github, Linkedin, Mail} from 'lucide-react';

const Contact = () => {
  const contactInfo = [
    {
      icon: <Mail size={24} />,
      label: 'Email',
      value: 'llemitjohnpaul15@gmail.com',
      link: 'mailto:llemitjohnpaul15@gmail.com',
    },
    {
      icon: <Github size={24} />,
      label: 'GitHub',
      value: '@Jipy815',
      link: 'https://github.com/Jipy815',
    },
    {
      icon: <Linkedin size={24} />,
      label: 'LinkedIn',
      value: 'John Paul Llemit',
      link: 'https://www.linkedin.com/in/john-paul-llemit-78230a299/',
    },
  ];

  return (
    <section id="contact" className="px-4 py-20 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="rounded-3xl bg-slate-950 px-6 py-12 text-center text-white shadow-2xl shadow-slate-300 sm:px-12 sm:py-16"><p className="text-sm font-bold uppercase tracking-[0.2em] text-cyan-300">Get in touch</p><h2 className="mx-auto mt-4 max-w-2xl text-4xl font-bold tracking-tight sm:text-5xl">Have an idea worth building?</h2><p className="mx-auto mt-5 max-w-xl text-lg leading-8 text-slate-300">I’m open to opportunities, collaborations, and conversations about thoughtful technology.</p><a href="mailto:llemitjohnpaul15@gmail.com" className="mt-8 inline-flex items-center gap-2 rounded-full bg-cyan-300 px-5 py-3 font-semibold text-slate-950 transition hover:-translate-y-0.5 hover:bg-cyan-200">Send an email <ArrowUpRight size={17} /></a></div>
        
        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {contactInfo.map((item, index) => (
            <a
              key={index}
              href={item.link}
              target={item.link.startsWith('http') ? '_blank' : undefined}
              rel="noopener noreferrer"
              className="group rounded-2xl border border-slate-200 bg-white p-5 text-center transition hover:-translate-y-1 hover:border-cyan-300 hover:shadow-lg hover:shadow-slate-200/70"
            >
              <div className="mb-3 flex justify-center text-cyan-700 transition-transform group-hover:scale-110">
                {item.icon}
              </div>
              <h3 className="mb-2 text-lg font-bold text-slate-950">{item.label}</h3>
              <p className="text-sm text-slate-600">{item.value}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;
